import { OptionalBooleanSelect } from "@/components/form"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import type { GenericInputProps } from "./InputComponent"

type Props = GenericInputProps<boolean>

const BooleanInput: ReactiveComponent<Props> = (props) => {
	return () => (
		<OptionalBooleanSelect value={props.value} setValue={props.setValue} nullText="Please select an option" required />
	)
}

export default defineComponent(BooleanInput, inferProps<Props>())
